export function billingRequest(data: BillingDetailsRequest) {
  return {
    ...data,
    stateRegion: data.stateRegion || null,
    vatId: data.vatId || null,
    companyIdentificationNumber: data.companyIdentificationNumber || null,
  };
}
